import React from 'react'
import styled from 'styled-components'

function ContentArea({ home, transparent, shadowless, fullsize, ...props }) {
  const contentShared = `
  align-items: center;
  border-radius: 1rem;
  box-sizing: border-box;
  color: #404040;
  display: flex;
  flex-direction: column;
  font-family: 'museo-sans', sans-serif;
  font-size: 1.25rem;
  font-weight; 500;
  justify-content: flex-start;
`

  const ContentDiv = styled.div`
    background-color: ${transparent ? `ffffffff` : `#ffffffdd`};
    box-shadow: ${shadowless ? `none` : `#41717638 2px 5px 16px`};
    flex: 1;
    margin: ${home ? `0` : `2rem`};
    max-height: ${fullsize ? `100%` : `calc(80vh - 4rem)`};
    width: ${home ? `100%` : `calc(100vw - 4rem)`};
    overflow-y: auto;
    ${contentShared}

    @media screen and (min-width: 768px) {
      margin: 0 auto 4rem;
      max-height: ${fullsize ? `100%` : `calc(100vh - 12rem)`};
      max-width: ${fullsize ? `100vw` : `40rem`};
    }
  `

  const Content = styled.div`
    box-sizing: border-box;
    overflow-y: auto;
    padding: ${home ? `0` : `1rem 0`};
    width: 100%;
    ${contentShared}

    @media screen and (min-width: 768px) {
      // margin: ${home ? `2.25rem 2rem` : `0`};
      padding: 2.25rem 2rem;
    }

    &:after {
      content: '';
      display: block;
      height: 2rem;
      min-height: 2rem;
      width: 100%;
    }

    h1 {
      font-size: 2.5rem;
      font-weight: 500;
      margin: 2rem 0 0 0;
      text-align: center;
    }

    h2 {
      font-size: 1.75rem;
      font-weight: 500;
      margin: 2rem 0 0 0;
      text-align: center;

      &:first-child {
        margin: 1rem 0 0 0;
      }
    }

    a {
      color: #3498db;
      font-size: 1.25rem;
      line-height: 1.375rem;
      text-align: center;
      text-decoration: none;

      &:hover {
        color: #2084c7;
      }
    }

    p,
    ul {
      align-self: flex-start;
      color: #707070;
      font-size: 1rem;
      line-height: 1.25rem;
    }

    ul {
      align-self: flex-start;
      padding-left: 0.75rem;
    }
  `
  return (
    <ContentDiv>
      <Content>{props.children}</Content>
    </ContentDiv>
  )
}

export default ContentArea
